import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Wrapper = styled.label`

  .calendarContainer {
    display: inline-block;
    height: 100%;

    .content {
      display: flex;

      svg {
        width: 1rem;
        height: 1rem;
        fill: currentColor;
      }

      .buttonCustom {
        padding: 0.5rem;
        background-color: ${theme.colors.primaryBlue};
        border-radius: 0.25rem;
        border-width: 1px;
        color: white;

        &:hover {
          background-color: ${theme.colors.info};
          cursor: pointer;
        }

        &:focus {
          outline: none;
        }
      }

      .inputCustom {
        background-color: white;
        appearance: none;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
        padding: 0.25rem 0.5rem;
        border-width: 1px;
        font-weight: 600;

        &:focus {
          outline: none;
        }
      }
    }
  }
`;
